import type { Theme } from '../../contract.js';
import { luceLight, luceDark } from './variants.js';

export const luceTheme: Theme = {
  id: 'luce',
  name: 'Luce',
  description: 'Instrument panel aesthetic. Ferrari-inspired.',
  swatches: ['#000000', '#F5D547', '#4ADE80'],
  variants: { light: luceLight, dark: luceDark },
  unlockedByDefault: true,
  costPoints: 0,
  // Theme charging sims: Luce's active-charging animation is the mass-spring
  // cloth/wave shader in the theme's gold, replacing the CSS LuceAnimation on
  // the charging surface. Variant here is the docstring default; the
  // dispatcher resolves cloth-dark / cloth-light from the runtime mode.
  chargingAnimation: 'shader',
  shaderKind: 'cloth',
  shaderVariant: 'cloth-dark',
};
